import { axiosApi } from '@/config/http';
import type { ApiResponse } from '@/config/http/types';
import type { AppointmentBlockReason } from '@/models/ReservationInterface';

export interface CancelReason {
  id: string;
  value: string;
}

export const getAppointmentBlockReasons = async () => {
  try {
    const response = await axiosApi.get<ApiResponse<AppointmentBlockReason[]>>(
      '/v1/appointment-blocks/reasons',
    );
    return response.data.response;
  } catch (error) {
    return [];
  }
};

export const getAppointmentCancelReasons = async () => {
  try {
    const response = await axiosApi.get<ApiResponse<Record<string, string>[]>>(
      '/v1/reservation-cancellations/reasons?is_active=true',
    );
    return response.data.response.map(reason => ({
      id: reason.code,
      value: reason.name,
    })) as CancelReason[];
  } catch (error) {
    return [] as CancelReason[];
  }
};

export default {
  getAppointmentBlockReasons,
  getAppointmentCancelReasons,
};
